import React from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';

interface IProps {
    isOpenVirtualKeyboard?: boolean;
    noSidePadding?: boolean;
    style?: React.CSSProperties;
}

const BaseButton: React.FC<React.HTMLAttributes<HTMLDivElement> & IProps> = ({
    isOpenVirtualKeyboard,
    noSidePadding,
    ...other
}) => <animated.div {...other} />;

export const BaseContainer = styled(BaseButton)<IProps>`
    margin: 0 auto;
    padding: 0 20px;
    max-width: 1400px;
    position: relative;
`;
